import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { HttpService } from '../../services/http/http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { tap, switchMap, catchError } from 'rxjs/operators';
import { EMPTY} from 'rxjs';

enum EliminaStep {
  PROFILO = 1,
  COMPETENZE = 2,
}

@Component({
  selector: 'app-elimina-profilo',
  templateUrl: './elimina-profilo.component.html',
  styleUrls: ['./elimina-profilo.component.scss'],
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  standalone: true,
})
export class EliminaProfiloComponent {
  constructor(
    public dialogRef: MatDialogRef<EliminaProfiloComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { idProposta: number;},
    public api: HttpService,
    public snackBar: MatSnackBar,
  ) {}

  step: EliminaStep = EliminaStep.PROFILO;
  get title(): string {
    return this.step === EliminaStep.PROFILO
      ? 'Eliminazione proposta'
      : 'Eliminazione competenze associate';
  }

  get message(): string {
    return this.step === EliminaStep.PROFILO
      ? 'Sei sicuro di voler eliminare la proposta di profilo professionale?'
      : 'Si deve procedere alla cancellazione anche delle competenze e relative Abilità e Conoscenze?';
  }

  handleClick(): void {
    this.step === EliminaStep.PROFILO
      ? this.handleProfiloStep()
      : this.handleCompetenzeStep();
  }

  private handleProfiloStep(): void {
    this.api
      .checkCompetenzeProfilo({ valore: this.data.idProposta })
      .pipe(
        switchMap((res: any) => {
          if (!res.result.booleano) {
            return this.eliminaProfilo$().pipe(
              tap(() => {
                this.snackBar.open('Profilo eliminato correttamente', 'close', {
                  panelClass: 'successSnack',
                });
                this.dialogRef.close(true);
              }),
            );
          } else {
            this.step = EliminaStep.COMPETENZE;
            return EMPTY;
          }
        }),
        catchError((error) => {
          console.error('Errore controllo competenze:', error);
          this.snackBar.open(
            'Errore durante il controllo delle competenze',
            'close',
            {
              panelClass: 'errorSnack',
            },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  private handleCompetenzeStep(): void {
    this.api
      .eliminaProfiloConCompetenze(this.data.idProposta)
      .pipe(
        tap((res: any) => {
          if (res.operation != 3) {
            let message = res.result.message;
            this.snackBar.open(
              message,
              'close',
              { panelClass: ['multi-line-snackbar', 'successSnack'] },
            );
            this.dialogRef.close(true);
          }
        }),
        catchError((error) => {
          console.error('Errore eliminazione competenze:', error);
          this.snackBar.open(
            "Errore durante l'eliminazione delle competenze",
            'close',
            { panelClass: 'errorSnack' },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  private eliminaProfilo$() {
    return this.api.eliminaProfilo(this.data.idProposta);
  }

  private eliminaProfiloDiretto(): void {
    this.eliminaProfilo$()
      .pipe(
        tap(() => {
          this.snackBar.open('Profilo eliminato correttamente', 'close', {
            panelClass: 'successSnack',
          });
          this.dialogRef.close(true);
        }),
        catchError((error) => {
          console.error('Errore eliminazione profilo:', error);
          this.snackBar.open(
            "Errore durante l'eliminazione del profilo",
            'close',
            {
              panelClass: 'errorSnack',
            },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  closeDialog(refresh: boolean, deletedCompetences: boolean = false): void {
    if (this.step === EliminaStep.COMPETENZE && !deletedCompetences) {
      this.snackBar.open(
        'Le competenze non eliminate saranno disponibili nella funzionalità GESTIONE COMPETENZE',
        'close',
        { panelClass: 'successSnack' },
      );
    }
    this.dialogRef.close(refresh || this.step === EliminaStep.COMPETENZE);
  }

  onNoClick(): void {
    if (this.step === EliminaStep.PROFILO) {
      this.closeDialog(false);
    } else {
      this.eliminaProfiloDiretto();
    }
  }
}
